import React, { useRef } from 'react';
import clsx from 'clsx';
import styles from './SearchPlayerInput.module.scss';
import IconSearch from '@static/images/icon_search.svg';
import { Image, useTranslation } from '@colonist/ui';
import { passThroughTranslation } from '@colonist/i18n';
export const SearchPlayerInput = ({ placeholder, onSearch, defaultValue = '', flatBottom = false, searchOnClear = false })=>{
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const handleSubmit = (event)=>{
        event.preventDefault();
        if (inputRef.current) onSearch(inputRef.current.value);
    };
    const handleIconClick = ()=>{
        if (inputRef.current) onSearch(inputRef.current.value);
    };
    const handleChange = (event)=>{
        if (searchOnClear && event.target.value === '') onSearch('');
    };
    const searchIconAlt = placeholder != undefined ? passThroughTranslation(placeholder) : {
        key: 'strings:popups.searchPlayer.title'
    };
    return /*#__PURE__*/ React.createElement("form", {
        className: clsx(styles.searchPlayerContainer, flatBottom && styles.flatBottom),
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement("input", {
        ref: inputRef,
        className: styles.searchInput,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : t('strings:popups.searchPlayer.title'),
        defaultValue: defaultValue,
        onChange: handleChange
    }), /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconSearch,
            alt: searchIconAlt
        },
        className: styles.searchIcon,
        onClick: handleIconClick
    }));
};
